import React from 'react';

export default function Help() {
  return (
    <div className="form-container">
      <h2>Serve aiuto? Sei nella pagina giusta</h2>
      <p><strong>NOVITÀ</strong></p>
      <p>Scopri le ultime promozioni e offerte di Brucaliffo Vape e tieniti aggiornato sulle ultime novità!</p>
      <p><strong>NEGOZI</strong></p>
      <p>Scopri il negozio più vicino a te. Trova tutte le informazioni utili, promozioni in corso, orari, servizi offerti e i nostri fantastici prodotti!</p>
      <p><strong>CARTA FEDELTÀ</strong></p>
      <p></p>
      <p><strong>CUPON</strong></p>
      <p></p>
      <p><strong>SPEDIZIONI</strong></p>
      <p></p>
    </div>
  );
}